import { Text, TextProps } from './Themed';
import './Style.css';

export function MonoText(props: TextProps) {
  return <Text {...props} style={[props.style, { fontFamily: 'space-mono' }]} />;
}

export function TextTitle(props: TextProps) {
  return <div {...props} className="title m-b-5" />;
}

export function TextGenre(props: TextProps) {
  return <div {...props} className="info m-b-10"/>;
}

export function MonoLink(props: TextProps) {
  return <a {...props} style={{ fontFamily: 'space-mono', fontSize: "12px", fontWeight: "normal" }} />;
}